import Confetti from 'react-confetti'
import useWindowDimensions from '../../app/hooks/useWindowDimensions'

const ConfettiComponent = () => {
  const { height, width } = useWindowDimensions()
  return <Confetti width={width} height={height} />
}

export default ConfettiComponent
